/**
 *
 * Asynchronously loads the component for CloudAccountWizard
 *
 */

import { lazyLoad } from 'utils/loadable';

export const CloudAccountWizard = lazyLoad(
  // @ts-ignore
  () => import('./index.tsx'),
  module => module.CloudAccountWizard,
);
